<ng-container [ngSwitch]="uiFramework">
  <div *ngSwitchCase="'ionic'">
    <ion-grid
      *ngIf="mode"
      class="w-full bg-accent-100 text-center p-0"
      fixed>
      <ion-row
        *ngIf="mode === 'hour-minute' && hoursMinutes"
        class="ion-align-items-center">
        <ion-col class="p-0" size="5">
          <ion-item class="radius-4 body-2" lines="full">
            <ion-select
              class="w-full data-type-select"
              interface="action-sheet"
              [placeholder]="hoursMinutes.hour"
              (ionChange)="onValueChange('hour', $any($event).detail.value)">
              <ion-select-option
                *ngFor="let _ of [].constructor(24); let index = index"
                [value]="index">
                {{ index }} {{ index < 12 ? 'AM' : 'PM' }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col class="p-0" size="2">
          <ion-label>:</ion-label>
        </ion-col>
        <ion-col class="p-0" size="5">
          <ion-item class="radius-4 body-2" lines="full">
            <ion-select
              class="w-full data-type-select"
              interface="action-sheet"
              [placeholder]="hoursMinutes.minute"
              (ionChange)="onValueChange('minute', $any($event).detail.value)">
              <ion-select-option
                *ngFor="let _ of [].constructor(60); let index = index"
                [value]="index">
                {{ index }} min
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="mode === 'month-day' && monthDay"
        class="ion-align-items-center">
        <ion-col class="p-0" size="5">
          <ion-item class="radius-4 body-2" lines="full">
            <ion-select
              class="w-full data-type-select"
              interface="action-sheet"
              [placeholder]="monthDay.month"
              (ionChange)="onValueChange('month', $any($event).detail.value)">
              <ion-select-option
                *ngFor="let _ of [].constructor(12); let index = index"
                [value]="index + 1">
                {{ index + 1 }} month
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col class="p-0" size="2">
          <ion-label>/</ion-label>
        </ion-col>
        <ion-col class="p-0" size="5">
          <ion-item class="radius-4 body-2" lines="full">
            <ion-select
              class="w-full data-type-select"
              interface="action-sheet"
              [placeholder]="monthDay.day"
              (ionChange)="onValueChange('day', $any($event).detail.value)">
              <ion-select-option
                *ngFor="let _ of [].constructor(31); let index = index"
                [value]="index + 1">
                {{ index + 1 }} day
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <div *ngSwitchCase="'material'">
    <div class="fx-row fx-wrap fx-gap-3">
      <ng-container *ngIf="mode === 'hour-minute' && hoursMinutes">
        <div class="fx-row fx-gap-3 fx-align-center">
          <div class="fx-col fx-gap-1">
            <div class="text-normal text-grey-400">
              Hour
            </div>
            <mat-form-field class="custom-mat-form-field custom-border-bottom">
              <mat-select [value]="+hoursMinutes.hour" (selectionChange)="onValueChange('hour', $event.value)">
                <mat-option *ngFor="let hour of createRange(24)" [value]="hour">
                  {{ hour }} {{ hour < 12 ? 'AM' : 'PM' }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="pt-6 fx-gap-1">
            <span class="text-normal">:</span>
          </div>
          <div class="fx-col fx-gap-1">
            <div class="text-normal text-grey-400">
              Minute
            </div>
            <mat-form-field class="custom-mat-form-field custom-border-bottom">
              <mat-select [value]="+hoursMinutes.minute" (selectionChange)="onValueChange('minute', $event.value)">
                <mat-option *ngFor="let minute of createRange(60)" [value]="minute">
                  {{ minute }} min
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="mode === 'month-day' && monthDay">
        <div class="fx-row fx-gap-3 fx-align-center">
          <div class="fx-col fx-gap-1">
            <div class="text-normal text-grey-400">
              Month
            </div>
            <mat-form-field class="custom-mat-form-field custom-border-bottom">
              <mat-select [value]="+monthDay.month" (selectionChange)="onValueChange('month', $event.value)">
                <mat-option *ngFor="let month of createRange(12)" [value]="month + 1">
                  {{ month + 1 }} month
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="fx-col pt-6">
            <span class="text-normal">/</span>
          </div>
          <div class="fx-col fx-gap-1">
            <div class="text-normal text-grey-400">
              Day
            </div>
            <mat-form-field class="custom-mat-form-field custom-border-bottom">
              <mat-select [value]="+monthDay.day" (selectionChange)="onValueChange('day', $event.value)">
                <mat-option *ngFor="let day of createRange(31)" [value]="day + 1">
                  {{ day + 1 }} day
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
